import Point from '@/geom/Point';

const GeomUtils = {
  addPoints(point1, point2) {
    const x = point1.x + point2.x;
    const y = point1.y + point2.y;
    return new Point(x, y);
  },
  async getCurrentMapPosition(projection) {
    const pos = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
    const { coords } = pos;
    return projection.locationToPoint(coords);
  },
  getDistance(topLeft, bottomRight, p) {
    const min = new Point(Math.min(topLeft.x, bottomRight.x), Math.min(topLeft.y, bottomRight.y));
    const max = new Point(Math.max(topLeft.x, bottomRight.x), Math.max(topLeft.y, bottomRight.y));
    var dx = Math.max(min.x - p.x, 0, p.x - max.x);
    var dy = Math.max(min.y - p.y, 0, p.y - max.y);
    return Math.sqrt(dx * dx + dy * dy);
  },
};

export default GeomUtils;
